import React, { useState, lazy } from 'react';
import FormInput from '../components/ui/FormInput';
import Button from '../components/ui/Button';
import { PhoneIcon, MailIcon, ClockIcon, MapPinIcon, CheckCircleIcon } from 'lucide-react';
const Contact = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real application, you would send the form data to a server
    console.log('Form submitted:', formData);
    setFormSubmitted(true);
  };
  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real application, you would send the email to a server
    console.log('Newsletter signup:', newsletterEmail);
    setNewsletterEmail('');
    alert('Thank you for subscribing to our newsletter!');
  };
  return <div className="w-full" data-id="element-272">
      {/* Page Header */}
      <section className="bg-primary py-16 relative overflow-hidden" data-id="element-273">
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: "url('data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"
      }} data-id="element-274"></div>
        <div className="container mx-auto px-4 text-center relative z-10" data-id="element-275">
          <h1 className="text-white font-bold mb-4" data-id="element-276">Contact Us</h1>
          <p className="text-white opacity-90 max-w-2xl mx-auto" data-id="element-277">
            We're here to help. Reach out to us with any questions or to
            schedule a consultation.
          </p>
        </div>
      </section>

      {/* Contact Info & Map */}
      <section className="py-16" data-id="element-278">
        <div className="container mx-auto px-4" data-id="element-279">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-280">
            {/* Contact Information */}
            <div data-id="element-281">
              <h2 className="font-bold mb-6" data-id="element-282">Get In Touch</h2>
              <div className="space-y-6" data-id="element-283">
                <div className="flex" data-id="element-284">
                  <MapPinIcon size={24} className="text-primary flex-shrink-0 mr-4" data-id="element-285" />
                  <div data-id="element-286">
                    <h3 className="font-semibold mb-2" data-id="element-287">Our Office</h3>
                    <address className="not-italic text-text-secondary" data-id="element-288">
                      3 Pickering St, #02-08
                      <br data-id="element-289" />
                      Singapore 048660
                      <br data-id="element-290" />
                      Singapore
                    </address>
                  </div>
                </div>
                <div className="flex" data-id="element-291">
                  <PhoneIcon size={24} className="text-primary flex-shrink-0 mr-4" data-id="element-292" />
                  <div data-id="element-293">
                    <h3 className="font-semibold mb-2" data-id="element-294">Phone</h3>
                    <p className="text-text-secondary" data-id="element-295">
                      <a href="tel:+6589701506" className="hover:text-primary" data-id="element-296">
                        +65 8970 1506
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-297">
                  <MailIcon size={24} className="text-primary flex-shrink-0 mr-4" data-id="element-298" />
                  <div data-id="element-299">
                    <h3 className="font-semibold mb-2" data-id="element-300">Email</h3>
                    <p className="text-text-secondary" data-id="element-301">
                      <a href="mailto:vjayvarmmanadmin@rep.greateasternfa.sg" className="hover:text-primary" data-id="element-302">
                        vjayvarmmanadmin@rep.greateasternfa.sg
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-303">
                  <ClockIcon size={24} className="text-primary flex-shrink-0 mr-4" data-id="element-304" />
                  <div data-id="element-305">
                    <h3 className="font-semibold mb-2" data-id="element-306">Business Hours</h3>
                    <p className="text-text-secondary" data-id="element-307">
                      Monday - Friday: By appointment only
                    </p>
                    <p className="text-text-secondary" data-id="element-308">
                      Saturday & Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Map */}
            <div data-id="element-309">
              <h2 className="font-bold mb-6" data-id="element-310">Our Location</h2>
              <div className="h-80 bg-gray-200 rounded-lg overflow-hidden" data-id="element-311">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8192424509883!2d103.84666907478945!3d1.2815774987147335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da190a6f6f0001%3A0xc9e5d2013e6a4bde!2s3%20Pickering%20St%2C%20Singapore%20048660!5e0!3m2!1sen!2ssg!4v1688978654317!5m2!1sen!2ssg" width="100%" height="100%" style={{
                border: 0
              }} allowFullScreen loading="lazy" title="Magnavera Group Office Location" className="rounded-lg" data-id="element-312"></iframe>
              </div>
              <p className="text-xs text-text-secondary mt-2" data-id="element-313">
                Magnavera Group is a group of representatives of Great Eastern
                Financial Advisers Pte Ltd (GEFA).
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Contact Form */}
      <section className="py-16 bg-background" data-id="element-314">
        <div className="container mx-auto px-4" data-id="element-315">
          <div className="max-w-2xl mx-auto" data-id="element-316">
            <h2 className="text-center font-bold mb-8" data-id="element-317">Send Us a Message</h2>
            {formSubmitted ? <div className="text-center bg-white p-8 rounded-lg shadow-card" data-id="element-318">
                <CheckCircleIcon size={48} className="text-primary mx-auto mb-4" data-id="element-319" />
                <h3 className="font-bold mb-2" data-id="element-320">Message Sent!</h3>
                <p className="text-text-secondary" data-id="element-321">
                  Thank you for reaching out. We'll get back to you within 24
                  hours.
                </p>
              </div> : <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-card" data-id="element-322">
                <FormInput label="Your Name" name="name" required value={formData.name} onChange={handleChange} data-id="element-323" />
                <FormInput label="Email Address" type="email" name="email" required value={formData.email} onChange={handleChange} data-id="element-324" />
                <FormInput label="Message" type="textarea" name="message" required placeholder="How can we help you?" value={formData.message} onChange={handleChange} data-id="element-325" />
                <div className="mt-6" data-id="element-326">
                  <Button type="submit" data-id="element-327">Send Message</Button>
                </div>
              </form>}
          </div>
        </div>
      </section>

      {/* Newsletter Signup */}
      <section className="py-16 bg-primary" data-id="element-328">
        <div className="container mx-auto px-4 text-center" data-id="element-329">
          <h2 className="text-white font-bold mb-4" data-id="element-330">Stay Updated</h2>
          <p className="text-white opacity-90 max-w-2xl mx-auto mb-8" data-id="element-331">
            Subscribe to our newsletter for financial tips, industry updates,
            and special event invitations.
          </p>
          <form onSubmit={handleNewsletterSubmit} className="max-w-md mx-auto flex flex-col sm:flex-row gap-4" data-id="element-332">
            <input type="email" placeholder="Your email address" className="flex-grow px-4 py-3 rounded-lg focus:outline-none" value={newsletterEmail} onChange={e => setNewsletterEmail(e.target.value)} required data-id="element-333" />
            <Button type="submit" className="bg-secondary hover:bg-secondary/90" data-id="element-334">
              Subscribe
            </Button>
          </form>
        </div>
      </section>
    </div>;
};
export default Contact;